<template>
  <div class="flex flex-col items-start justify-start">
    <div class="version">
      {{ Env }}
      <el-tooltip effect="light">
        <template #content>
          当前版本信息
          <strong class="text-red-500">仅在</strong>开发、测试环境中显示，
          <strong class="text-red-500">不会</strong>显示
          <strong class="text-green-500">生产环境</strong>中。
        </template>
        <el-icon
          size="14"
          class="hover:text-primary-button-hover ml-1 text-yellow-700 hover:cursor-pointer"
        >
          <WarningFilled />
        </el-icon>
      </el-tooltip>
    </div>
    <div class="version">{{ `${version}-${test}` }}</div>
  </div>
</template>

<script lang="ts" setup>
import pack from '../../../../../package.json'

const { version, 'test-version': test } = pack

const Env = import.meta.env.MODE.toUpperCase()
</script>

<style scoped>
.version {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  @apply font-CS;
  font-size: 12px;
}
</style>
